export default __webpack_public_path__ + "static/media/env.f3bbcc03.local";